'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _SearchFilter = require('./SearchFilter');

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collections_Header = function (_React$Component) {
	_inherits(Collections_Header, _React$Component);

	function Collections_Header() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Collections_Header);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Collections_Header.__proto__ || Object.getPrototypeOf(Collections_Header)).call.apply(_ref, [this].concat(args))), _this), _this.resetForm = function () {
			_this.refs.sForm.reset();
			_this.props.resetSearchResults();
			_this.props.updateSearchTerm('');
		}, _this.doSearch = function (event) {
			event.preventDefault();
			_this.handleSearch();
		}, _this.handleSearch = function () {

			if (_this.props.searchIsLoading) {
				return;
			}

			if (!_this.refs.searchInput.value) {
				if (iconPressConfig.debug === '1') {
					console.log('Empty search query!');
				}
				return;
			}

			var sVal = _this.refs.searchInput.value.substr(0, 20);
			_this.props.updateSearchTerm(sVal);
			_this.props.performSearch(sVal);
		}, _this.handleKeyUp = function (event) {
			clearTimeout(_this.timeout);
			_this.timeout = setTimeout(function () {
				return _this.handleSearch();
			}, 1000);
		}, _this.handleFilter = function (event) {
			// reset search form
			_this.resetForm();
			// make the filtering
			_this.props.setFilter(event.target.value);
		}, _this.handleFilter_Search = function (event) {
			// make the filtering
			_this.props.filterSearch(event.target.value);
		}, _this.escCloseSearch = function (event) {
			// reset search form on escape key
			if (_this.props.searchTerm != '' && event.keyCode === 27) {
				_this.resetForm();
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Collections_Header, [{
		key: 'componentDidMount',
		value: function componentDidMount() {

			document.addEventListener("keydown", this.escCloseSearch, false);

			if (this.props.searchTerm != '') {
				this.refs.searchInput.value = this.props.searchTerm;
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			document.removeEventListener("keydown", this.escCloseSearch, false);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'ip-collectionsHeader' },
				_react2.default.createElement(
					'div',
					{ className: 'ip-searchForm' },
					_react2.default.createElement(
						'form',
						{ onSubmit: this.doSearch, ref: 'sForm' },
						_react2.default.createElement('input', { type: 'text', placeholder: iconPressConfig.translations.TYPE_TO_SEARCH_FOR_ICON, ref: 'searchInput', onKeyUp: function onKeyUp(event) {
								return _this2.handleKeyUp(event);
							} }),
						_react2.default.createElement(
							'div',
							{ className: 'ip-searchIndicator ' + (this.props.searchTerm != '' ? 'is-searching' : '') + ' ' },
							!this.props.searchTerm && _react2.default.createElement(_SvgIcon2.default, { icon: 'search' }),
							this.props.searchTerm && _react2.default.createElement(_SvgIcon2.default, { icon: 'close-thin', onClick: this.resetForm })
						),
						this.props.showFilter && (!this.props.searchTerm ? _react2.default.createElement(_SearchFilter2.default, {
							title: iconPressConfig.translations.FILTER,
							handleFilter: this.handleFilter,
							filter: this.props.filter,
							className: this.props.componentIsLoading || this.props.searchIsLoading || this.props.newCollectionIsLoading ? 'u-pevn u-op5' : ''
						}) : _react2.default.createElement(_SearchFilter2.default, {
							title: iconPressConfig.translations.FILTER_SEARCH,
							handleFilter: this.handleFilter_Search,
							filter: this.props.filter,
							className: this.props.componentIsLoading || this.props.searchIsLoading || this.props.newCollectionIsLoading ? 'u-pevn u-op5' : ''
						}))
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'ip-collectionsHeader-size' },
					_react2.default.createElement(
						'label',
						{ className: 'ip-label', htmlFor: 'ip-size-select' },
						iconPressConfig.translations.ICON_SIZE
					),
					_react2.default.createElement(
						'select',
						{ className: 'ip-selectList', id: 'ip-size-select', value: this.props.size, onChange: this.props.updateSize },
						[16, 24, 32, 64, 128].map(function (key) {
							return _react2.default.createElement(
								'option',
								{ key: key, value: key },
								key,
								'px'
							);
						})
					)
				)
			);
		}
	}]);

	return Collections_Header;
}(_react2.default.Component);

exports.default = Collections_Header;


//////////////////
// WEBPACK FOOTER
// ./src/components/Collections_Header.js
// module id = 255
// module chunks = 0 1